import { Loader, Stack } from "@mantine/core";
import { modals } from "@mantine/modals";
import { useState } from "react";

const ScribeModal = (props: { src: string }) => {
    const [isLoading, setIsLoading] = useState(true);

    const [height, width] = [551, 640];

    return (
        <Stack h={height} w={width} gap={0}>
            {isLoading && <Loader pos="relative" top="50%" h={0} />}
            <iframe
                src={props.src}
                width={width}
                height={height}
                allow="fullscreen"
                style={{ aspectRatio: "1 / 1", border: 0, minHeight: "480px" }}
                onLoad={() => setIsLoading(false)}
            />
        </Stack>
    );
};

export function useScribeModal({ src }: { src: string }) {
    return {
        present: () => {
            modals.open({
                size: "auto",
                withCloseButton: false,
                children: <ScribeModal src={src} />,
                styles: {
                    body: { padding: 0 },
                },
            });
        },
    };
}
